import React from "react";

import { Grid } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import FieldView from "../../../../../../../components/Form/FieldView";
import { Staff } from "../../../../../../../models/staff";
import { Transshipment } from "../../../../../../../models/transshipment";
import { Details, DetailsTitle } from "./styles";
import { useAppState } from "Context/StateContext";
import { formatDateWithUserPref } from "Util/dateFormaterPreference";

interface Props {
  transshipment?: Transshipment;
}

export const DetailsTab = ({ transshipment }: Props) => {
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  const getStaffsFormatted = (staffs?: Staff[]) => {
    const nameStaffs: Array<string> = [];

    if (staffs && staffs.length > 0) {
      staffs?.forEach((staff) => {
        if (staff?.firstName && staff?.lastName) {
          nameStaffs.push(`${staff?.firstName} ${staff?.lastName}`);
        } else if (staff?.firstName) {
          nameStaffs.push(staff?.firstName);
        }
      });
    }

    return nameStaffs?.join(", ");
  };

  return (
    <Details>
      <Grid container direction="row" alignItems="center">
        <DetailsTitle>{translate("generalDetails")}</DetailsTitle>
      </Grid>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView label={translate("reference")} value={transshipment?.reference} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView label={translate("type")} value={transshipment?.type?.name || ""} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView
            label={translate("dueDateBy")}
            value={
              transshipment?.dueBy && currentUser?.preferences
                ? formatDateWithUserPref(transshipment?.dueBy, currentUser.preferences, "dateOnly")
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView label={translate("status")} value={transshipment?.status || ""} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView label={translate("warehouse")} value={transshipment?.warehouse?.name || ""} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView
            label={translate("requestedBy")}
            value={transshipment?.createdBy?.fullName || ""}
          />
        </Grid>
      </Grid>

      <DetailsTitle>{translate("team")}</DetailsTitle>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView label={translate("assigned")} value={transshipment?.leader?.fullName || ""} />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={2}>
          <FieldView
            label={translate("staff")}
            value={getStaffsFormatted(transshipment?.task?.staffs) || ""}
          />
        </Grid>
      </Grid>
    </Details>
  );
};
